/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Help_TitleInputs */

const en_seo_help_title = /** @type {(inputs: Seo_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help centre for trainers`)
};

const pl_seo_help_title = /** @type {(inputs: Seo_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum pomocy dla trenerów`)
};

/**
* | output |
* | --- |
* | "Help centre for trainers" |
*
* @param {Seo_Help_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_help_title = /** @type {((inputs?: Seo_Help_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Help_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_help_title(inputs)
	return en_seo_help_title(inputs)
});